import { Link, useParams } from 'react-router-dom';

import { sortBy } from 'helpers';
import { observer, useLocalObservable } from 'mobx-react-lite';

import { Button } from '@components/button';
import { RadioGroup } from '@components/radio-group';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Grid, GridColumn } from 'components/Grid';
import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

export const PromoteSelectBoard = observer(({ selectBoard, boards }) => {
  const { t } = useStore();
  const params = useParams();

  const local = useLocalObservable(() => ({
    selected: null,
    select(value) {
      local.selected = value;
    },
    submit() {
      selectBoard(local.selected);
    },
    get radioOptions() {
      return sortBy(
        boards.map((board) => ({
          label: configs[board.name].title,
          value: board.name,
        })),
        'display',
      );
    },
  }));

  return (
    <Grid>
      <GridColumn span="4">
        <Stack space={6}>
          <Text font="heading2">{t('jobboards.select.heading')}</Text>
          <Separator />
          <RadioGroup
            label="Select job board"
            hideLabel
            options={local.radioOptions}
            onChange={local.select}
            defaultValue={local.selected}
          />
          <Separator />

          <Stack orientation="horizontal" space={4} justify="flex-end">
            <Link to={`/jobs/${params.jobID}/promote`}>
              <Button variant="secondary" text={t('jobboards.select.cancel')} />
            </Link>
            <Button
              isDisabled={!local.selected}
              onClick={local.submit}
              text={t('jobboards.select.go')}
            />
          </Stack>
        </Stack>
      </GridColumn>
    </Grid>
  );
});
